// import { useState } from 'react';
import { videos } from "../constants/videos";
import { ReactComponent as VideosIcon } from "../icons/videos.svg";
import { ReactComponent as NewWindowIcon } from "../icons/new-window.svg";
import Glenn_Conner from "../assets/images/siblings/stamps/Glenn_Conner.png";
import Ruth_Edgler from "../assets/images/siblings/stamps/Ruth_Edgler.png";
import James_Stanley_Conner from "../assets/images/siblings/stamps/James_Stanley_Conner.png";
import Joanna_Corman from "../assets/images/siblings/stamps/Joanna_Corman.png";
import Marjorie_Dudley from "../assets/images/siblings/stamps/Marjorie_Dudley.png";
import Marvin_Conner from "../assets/images/siblings/stamps/Marvin_Conner.png";
import Mary_Miller from "../assets/images/siblings/stamps/Mary_Miller.png";
import Richard_Leighton from "../assets/images/siblings/stamps/Richard_Leighton.png";
import William_Conner from "../assets/images/siblings/stamps/William_Conner.png";
import Wilma_Jackson from "../assets/images/siblings/stamps/Wilma_Jackson.png";

export default function VideoList() {
  return (
    <>
      <h3>Memories Videos</h3>
      <ul className="accordion vidlist">
        {
          videos.map((sibling, index) => {
            const { type, label, url, stamp } = sibling;
            return <CustomVideoItem key={index} type={type} label={label} url={url} stamp={stamp} />
          })
        }
      </ul>
    </>
  );
}

function CustomVideoItem({ type, label, url, stamp }) {
  const stampComponents = {
    "Glenn_Conner": <img className="sibicon" src={Glenn_Conner} alt="thumbnail image of Glenn Conner" aria-hidden="true" />,
    "Marvin_Conner": <img className="sibicon" src={Marvin_Conner} alt="thumbnail image of MarvinConner" aria-hidden="true" />,
    "Ruth_Edgler": <img className="sibicon" src={Ruth_Edgler} alt="thumbnail image of Ruth Edgler" aria-hidden="true" />,
    "Wilma_Jackson": <img className="sibicon" src={Wilma_Jackson} alt="thumbnail image of Wilma Jackson" aria-hidden="true" />,
    "Joanna_Corman": <img className="sibicon" src={Joanna_Corman} alt="thumbnail image of Joanna Corman" aria-hidden="true" />,
    "Mary_Miller": <img className="sibicon" src={Mary_Miller} alt="thumbnail image of Mary Miller" aria-hidden="true" />,
    "James_Stanley_Conner": <img className="sibicon" src={James_Stanley_Conner} alt="thumbnail image of James Stanley Corman" aria-hidden="true" />,
    "Marjorie_Dudley": <img className="sibicon" src={Marjorie_Dudley} alt="thumbnail image of Marjorie Dudley" aria-hidden="true" />,
    "Richard_Leighton": <img className="sibicon" src={Richard_Leighton} alt="thumbnail image of Richard Leighton" aria-hidden="true" />,
    "William_Conner": <img className="sibicon" src={William_Conner} alt="thumbnail image of William Connerf" aria-hidden="true" />,
  }

  let thisIcon = '';
  switch (type) {
    case 'liblink':
      thisIcon = <VideosIcon aria-hidden="true" />;
      break;
    case 'siblink':
      thisIcon = (stampComponents.hasOwnProperty(stamp) ? stampComponents[stamp] : '');
      break;
    default:
      break;
  }

  // const handleKeyDown = (event) => {
  //   if (event.key === 'Enter') {
  //     handleClick(event);
  //   }
  // };

  function handleClick(event) {
    event.preventDefault();
    window.open(url, "ConnerPhotos").focus();
  }

  return (
    <li className="sibvidlink">
      <button onClick={(e) => handleClick(e)}>
        {type === 'siblink' && <div className="pre-icon">{thisIcon}</div>}
        <div><span className="sr-only">video for </span>{label}<span className="sr-only">, opens in new window</span></div>
        <div className="expcol-button">{<NewWindowIcon aria-hidden="true" />}</div>
      </button>
    </li>
  );
}
